import DatePickerFilter from '@features/regional-overview/components/date-picker-filter';
import { useFiltersStore } from '@features/regional-overview/components/filters/filters.store';
import RegionalRiskFilterSelectSearch from '@features/regional-overview/components/regional-risk-filter-search/regional-risk-filter-search';
import { RegionalOverviewFilterType } from '@features/regional-overview/regional-overview.models';
import React, { useCallback } from 'react';
import { useDigitalTrapsStore } from '../../digital-traps.zustand';
import type { FilterContext } from '../../domain';
import { DigitalTrapFilterType } from '../../domain';
import { DIGITAL_TRAPS_FILTERS_CONTAINER } from '../../domain/tests-id.constants';
import { useDigitalTrapsFilters } from './digital-traps-filters.hook';
import styles from './digital-traps-filters.module.css';

interface DigitalTrapsFiltersContainerProps {
  enabledFilters: DigitalTrapFilterType[];
  context: FilterContext;
}

const DigitalTrapsFiltersContainer = ({ enabledFilters, context }: DigitalTrapsFiltersContainerProps) => {
  const { handleSearchChange, handleDateChange } = useDigitalTrapsFilters({ context });
  const selectedDate = useDigitalTrapsStore(state => state.selectedDate);
  const textSearchValue = useFiltersStore(state => state.values[RegionalOverviewFilterType.TEXT_SEARCH]);
  const textSearch = typeof textSearchValue === 'string' ? textSearchValue : '';

  const isFilterEnabled = useCallback(
    (filter: DigitalTrapFilterType): boolean => {
      return enabledFilters.includes(filter);
    },
    [enabledFilters]
  );

  return (
    <div className={styles.container} data-testid={DIGITAL_TRAPS_FILTERS_CONTAINER}>
      {isFilterEnabled(DigitalTrapFilterType.TEXT_SEARCH) && (
        <RegionalRiskFilterSelectSearch onChange={handleSearchChange} value={textSearch} className={styles.searchInput} />
      )}
      {isFilterEnabled(DigitalTrapFilterType.CURRENT_DATE) && (
        <DatePickerFilter onChange={handleDateChange} selectedValue={selectedDate} blockFutureDates />
      )}
    </div>
  );
};

const MemoizedDigitalTrapsFiltersContainer = React.memo(DigitalTrapsFiltersContainer);
export default MemoizedDigitalTrapsFiltersContainer;
